<template>
    <div class="not-found">
        <h1 class="title">Talki</h1>
        <h1>404-Página no encontrada</h1>
        <button class="button" @click="goToRoute()">Regresar</button>
    </div>
</template>
      
<script>
import router from "@/router";

export default {
    name: "NotFoundView",
    methods: {
        goToRoute() {
            if(localStorage.getItem("token") == null){
                router.push("/");
            }
            else{
                router.push("/home");
            }
        },
    },
};
</script>
    
<style scoped>
.not-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: var(--main-color);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    gap: 20px;
}

h1 {
    color: white;
    margin: 0;
}

.title {
    font-size: 50px;
}

.button {
    width: 200px;
    background-color: white;
    color: var(--main-color);
    border: none;
    padding: 15px 20px;
    cursor: pointer;
    font-size: 20px;
    letter-spacing: 1.2px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    transition: all ease-out 0.2s;
    -webkit-transition: all ease-out 0.2s;
    -moz-transition: all ease-out 0.2s;
    -ms-transition: all ease-out 0.2s;
    -o-transition: all ease-out 0.2s;
    text-transform: uppercase;
}

.button:hover {
    transform: scale(1.05);
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -ms-transform: scale(1.05);
    -o-transform: scale(1.05);
}
</style>